import React from 'react'
import styled from 'styled-components';

const ContentStyle = styled.div`
  h2 {
    color: #333333;
    margin: 30px 0;
  }
  .desc {
    color: #7D8A96;
    font-size: 15px;
    line-height: 26px;
    padding-bottom: 40px;
    border-bottom: 1px solid #AEB7C1;
  }
  .list-piece {
    line-height: 24px;
    font-size: 16px;
    color: #7D8A96;
    list-style: disc;
    >li {
      margin-left: 20px;
      margin-bottom: 6px;
    }
  }
  .md-40 {
    margin-bottom: 40px;
  }
  .flex-j {
    display: flex;
    flex-wrap: wrap;
  }
  @media (max-width: 768px) {
    h2 {
      margin: 20px 0;
    }
  }
`;

const W66 = styled.div`
  width: 66.6%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const W33 = styled.div`
  width: 33.3%;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export default function Content(props) {
  return (
    <ContentStyle>
      <div className="flex-j">
        <W66>
          <h2 className="h2">Grant</h2>
          <div className="desc">
            <p>DAOeco is an organization initiated by Trias community and focuses on the research of token economic model. DAOeco is composed of a group of economy enthusiasts from all over the world, including economists, researchers, university professors, etc. who hope to put forward a reasonable economic mechanism and governance model through theoretical research, so as to provide an efficient and feasible scheme for the certificate economy design of the project.</p>
            <p>DAOeco will collect ideas from the community, and conduct research and analysis, and design token economic sheme and model.</p>
            <p>One of the recent research direction of DAOeco is to design a Quadratic voting scheme for Trias grant. Quadratic voting is a relatively fair voting method. Compared with one person one vote and one currency one vote, Quadratic voting can expand the influence of ordinary people in participating in community governance, curb the control of the rich over the community, and let more people benefit from community governance.</p>
            <p>DAOeco receives grants from the community. In return, grant contributors can obtain the memorial NFT from DAOeco.</p>
          </div>
        </W66>
        <W33>
          {props.children}
        </W33>
      </div>
      <W66>
        <h2 className="h2">Grant Details:</h2>
        <ul className="list-piece">
          <li>Grant participants：TRIAS holders</li>
          <li>Grant period：No special time limit</li>
          <li>Grant token：TRIAS</li>
          <li>Wallet type: BSC wallet</li>
          <li>Grant hard cap：1000 TRIAS</li>
          <li>Grant soft cap：50 TRIAS</li>
        </ul>
      </W66>
      <W66>
        <h2 className="h2">Grant Guideline:</h2>
        <ul className="list-piece md-40">
          <li>Get TRIAS from exchanges and withdraw to your personal BSC wallet.</li>
          <li>Connect your personal wallet and grant TRIAS to support the specific grant.</li>
          <li>Wait for the grant to end.</li>
          <li>If the project is successfully launched, the initiator can use the corresponding TRIAS token to organize the related activities. Meanwhile, you will be notified of the progress. </li>
          <li>You will get the memorial NFT from DAOeco as a recognition and appreciation of this grant.</li>
          <li>If the project is failed (raised less than the soft cap), your TRIAS will be returned.</li>
        </ul>
      </W66>
    </ContentStyle>
  )
}
